import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { routePaths } from '../../urls'
import StatusMarker from '../StatusMarker'

class BrightspaceSetup extends React.Component {
  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    let { coursenum, courseToken } = this.context.store.getState()
    let setupIcon = courseToken ? 'icon_checkmark' : 'icon_notification'
    let nextLink = (
      <Link to={routePaths.brightspaceAssessments} className="btn btn-myed btn-default btn-default-myed">
        Next
      </Link>
    )
    let nextButton = courseToken ? nextLink : null
    let authLink = `/links/client_brightspace.authenticate/${coursenum}/`

    return (
      <div>
        <div className="canvas-flex-wrapper">
          <div className="canvas-form-container">
            <h2>1. Brightspace Setup</h2>
            <p>
              Use the button below to authenticate your Brightspace account.
              After successful authentication, you&apos;ll be redirected back
              here.
            </p>
            <a className="btn btn-myed btn-primary btn-primary-myed" href={authLink}>
              Authenticate
            </a>
            {nextButton}
          </div>
          <div className="canvas-statusmarker-container">
            <StatusMarker iconType={setupIcon} />
          </div>
        </div>
      </div>
    )
  }
}

BrightspaceSetup.contextTypes = {
  store: PropTypes.object,
}

export default BrightspaceSetup
